var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import clamp from 'lodash/clamp';
import * as React from 'react';
import { ChangeTimeValueOperation, DEFAULT_VALUE_FULL } from '../../constants/constants';
import { convertMillisecondsToString, convertStringToMilliseconds, isNumber } from '../../util-components/duration';
import Button from '../button';
import Icon from '../icon';
import { Styled } from './style';
var DurationInput = /** @class */ (function (_super) {
    __extends(DurationInput, _super);
    function DurationInput(props) {
        var _this = _super.call(this, props) || this;
        _this.setInitialState = function () {
            if (_this.props.value > 0) {
                return Number(_this.props.value);
            }
            else {
                return _this.props.defaultValue || Number(_this.props.value);
            }
        };
        _this.getDefaultMinMaxDuration = function () {
            // get default range of duration from min and max props
            // if user not define min max default should be [ min: 00:00:05 ,  max: 23:59:59 ]
            if (_this.props.min > _this.props.max) {
                throw Error('Min duration should be less than max duration');
            }
            return [_this.props.min, _this.props.max];
        };
        _this.formatTimeItem = function (value) {
            // todo: can be removed?
            return ((value || '') + "00").substr(0, 2);
        }; // time should be at least two digits
        _this.validateDurationValue = function (value) {
            var _a = value.split(':'), newHour = _a[0], newMinute = _a[1], newSecond = _a[2];
            var addedValueDuration = (Number(newHour) * 60 * 60 + Number(newMinute) * 60 + Number(newSecond)) * 1000;
            var _b = _this.getDefaultMinMaxDuration(), min = _b[0], max = _b[1]; // get min max from props if user set the range
            return convertMillisecondsToString(clamp(addedValueDuration, min, max));
        };
        _this.onSubmitTimeValue = function (timeValue) {
            if (_this.state.lastestSubmitValue !== timeValue) {
                _this.props.onDurationValueChange(timeValue);
                _this.setState({ lastestSubmitValue: timeValue });
            }
        };
        _this.cancelDebounceUpdateDuration = function () {
            if (_this.debounceUpdateDutation) {
                clearTimeout(_this.debounceUpdateDutation);
                _this.debounceUpdateDutation = null;
            }
        };
        _this.updateDebounceFocus = function () {
            if (_this.debounceUpdateDutation) {
                _this.cancelDebounceUpdateDuration();
            }
            _this.debounceUpdateDutation = setTimeout(function () {
                _this.props.onFocus && _this.props.onFocus(true);
                _this.setState({ isDurationChanging: false });
            }, 250);
        };
        _this.onInputChange = function (event) {
            var oldValue = _this.state.value;
            var inputElement = event.target;
            var inputValue = inputElement.value;
            var position = inputElement.selectionEnd;
            var isUserAddNewCharacter = inputValue.length > oldValue.length; // detect user add or remove character
            var addedCharacter = isUserAddNewCharacter ? inputValue[position - 1] : null; // user adding chatacter
            var removedCharacter = isUserAddNewCharacter ? null : oldValue[position]; // user removing character
            var newValue = oldValue;
            var newCursorPosition = position;
            _this.updateDebounceFocus();
            if (addedCharacter !== null) {
                if (position > _this.maxLength) {
                    newCursorPosition = _this.maxLength; // cannot add more  character, position cursor don't move
                }
                else if ((position === 3 || position === 6) && addedCharacter === ':') {
                    // when current position before colon (:), ignore colon and add character after colon 1 step
                    newValue = inputValue.substr(0, position - 1) + ":" + inputValue.substr(position + 1);
                }
                else if ((position === 3 || position === 6) && isNumber(addedCharacter)) {
                    // when user typing and current cursor next to colon (:) , next cursor position move 2 steps
                    newValue = inputValue.substr(0, position - 1) + ":" + addedCharacter + inputValue.substr(position + 2);
                    newCursorPosition = position + 1;
                }
                else if (isNumber(addedCharacter)) {
                    // user typed a number
                    newValue = inputValue.substr(0, position - 1) + addedCharacter + inputValue.substr(position + 1);
                    if (position === 2 || position === 5) {
                        // ignore colon and move to next position
                        newCursorPosition = position + 1;
                    }
                }
                else {
                    // if user typed NOT a number, then keep old value & position
                    newCursorPosition = position - 1;
                }
            }
            else if (removedCharacter !== null) {
                if ((position === 2 || position === 5) && removedCharacter === ':') {
                    newValue = inputValue.substr(0, position - 1) + "0:" + inputValue.substr(position);
                    newCursorPosition = position - 1;
                }
                else {
                    // user removed a number
                    newValue = inputValue.substr(0, position) + "0" + inputValue.substr(position);
                }
            }
            var validatedTime = _this.validateDurationValue(newValue);
            _this.setState({ value: validatedTime }, function () {
                inputElement.selectionStart = newCursorPosition;
                inputElement.selectionEnd = newCursorPosition;
            });
            event.persist();
        };
        _this.updateDuration = function (position, durationMillisecond, operation) {
            if (position >= 6) {
                durationMillisecond = durationMillisecond + operation * 1000; // 1 second
            }
            else if (position >= 3 && position < 6) {
                durationMillisecond = durationMillisecond + operation * 60 * 1000; // 1 min
            }
            else if (position < 3) {
                durationMillisecond = durationMillisecond + operation * 60 * 60 * 1000; // 1 hour
            }
            return durationMillisecond;
        };
        _this.onKeyChange = function (event) {
            var position = _this.state.focusPosition;
            var inputElement = event.target;
            var _a = _this.state.value.split(':'), hour = _a[0], minute = _a[1], second = _a[2];
            var newCursorPosition = inputElement.selectionStart;
            var duration = (Number(hour) * 60 * 60 + Number(minute) * 60 + Number(second)) * 1000;
            var operation = ChangeTimeValueOperation.DEFAULT; // keyboard up and down operation
            if (event.keyCode === 40) {
                // keyboard arrow down
                operation = ChangeTimeValueOperation.MINUS;
                _this.updateDebounceFocus();
                event.preventDefault();
            }
            else if (event.keyCode === 38) {
                // keyboard arrow up
                event.preventDefault();
                _this.updateDebounceFocus();
                operation = ChangeTimeValueOperation.PLUS;
            }
            else if (event.keyCode === 13) {
                // keyboard Enter
                event.preventDefault();
                if (_this.inputRef && _this.inputRef.current) {
                    _this.inputRef.current.blur();
                }
            }
            duration = _this.updateDuration(position, duration, operation);
            var newValue = convertMillisecondsToString(duration);
            var validatedTime = _this.validateDurationValue(newValue);
            _this.onSubmitTimeValue(convertStringToMilliseconds(validatedTime));
            _this.setState({ value: validatedTime }, function () {
                inputElement.selectionStart = newCursorPosition;
                inputElement.selectionEnd = newCursorPosition;
            });
            event.persist();
        };
        _this.onInputSelect = function (e) {
            var inputElement = e.target;
            _this.setState({ focusPosition: inputElement.selectionStart });
        };
        _this.onClickTimeChange = function (e, operation) {
            e.stopPropagation();
            e.preventDefault();
            var _a = _this.state.value.split(':'), hour = _a[0], minute = _a[1], second = _a[2];
            var duration = (Number(hour) * 60 * 60 + Number(minute) * 60 + Number(second)) * 1000;
            duration = _this.updateDuration(_this.state.focusPosition, duration, operation);
            var newValue = convertMillisecondsToString(duration);
            var validatedTime = _this.validateDurationValue(newValue);
            _this.setState({ value: validatedTime }, function () {
                // still focus when user click increase or decrease button
                if (_this.inputRef && _this.inputRef.current) {
                    _this.inputRef.current.focus();
                    _this.inputRef.current.selectionStart = _this.state.focusPosition;
                    _this.inputRef.current.selectionEnd = _this.state.focusPosition;
                }
            });
            _this.updateDebounceFocus();
        };
        _this.onDetectPositionClick = function (e) {
            // detect user click on input the position should be first letter of time digit
            var inputElement = e.target;
            if (inputElement.selectionStart < 2) {
                inputElement.selectionStart = 0;
                inputElement.selectionEnd = 0;
            }
            else if (inputElement.selectionStart >= 3 && inputElement.selectionStart < 6) {
                inputElement.selectionStart = 3;
                inputElement.selectionEnd = 3;
            }
            else if (inputElement.selectionStart >= 6) {
                inputElement.selectionStart = 6;
                inputElement.selectionEnd = 6;
            }
            if (_this.props.onFocus) {
                _this.props.onFocus(true);
            }
            _this.setState({ isDurationChanging: true });
        };
        _this.handleInputBlur = function (event) {
            var currentTarget = event.currentTarget;
            if (!currentTarget.contains(document.activeElement)) {
                _this.onSubmitTimeValue(convertStringToMilliseconds(_this.state.value));
            }
            if (_this.props.onFocus) {
                _this.props.onFocus(false);
            }
        };
        _this.inputRef = React.createRef();
        _this.configure();
        _this.state = {
            lastestSubmitValue: _this.setInitialState(),
            value: convertMillisecondsToString(_this.setInitialState()),
            focusPosition: 0,
            isDurationChanging: false,
        };
        return _this;
    }
    DurationInput.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.value !== this.props.value || prevProps.defaultValue !== this.props.defaultValue) {
            var validatedTime = this.validateDurationValue(convertMillisecondsToString(this.setInitialState()));
            this.setState({ value: validatedTime });
        }
    };
    DurationInput.prototype.configure = function () {
        this.defaultDuration = DEFAULT_VALUE_FULL;
        this.maxLength = this.defaultDuration.length;
    };
    DurationInput.prototype.render = function () {
        var _this = this;
        var _a = this.state, value = _a.value, focusPosition = _a.focusPosition;
        var _b = this.props, defaultValue = _b.defaultValue, isDisabled = _b.isDisabled, inverted = _b.inverted, fullWidth = _b.fullWidth, showBorder = _b.showBorder, style = _b.style, className = _b.className;
        return (React.createElement(Styled, { onBlur: this.handleInputBlur, style: style, className: className, fullWidth: fullWidth, isDisabled: isDisabled, inverted: inverted, currentPosition: focusPosition, showBorder: showBorder, defaultValue: defaultValue, value: this.props.value },
            React.createElement(Button, { tabIndex: -1, onClick: function (e) { return _this.onClickTimeChange(e, ChangeTimeValueOperation.PLUS); }, icon: true, className: "increase-btn" },
                React.createElement(Icon, { name: "caret-up" })),
            React.createElement("input", { ref: this.inputRef, type: "text", className: "input", value: value, onSelect: this.onInputSelect, onKeyDown: this.onKeyChange, onChange: this.onInputChange, onClick: this.onDetectPositionClick, disabled: isDisabled }),
            React.createElement(Button, { tabIndex: -1, onClick: function (e) { return _this.onClickTimeChange(e, ChangeTimeValueOperation.MINUS); }, icon: true, className: "decrease-btn" },
                React.createElement(Icon, { name: "caret-down" }))));
    };
    DurationInput.defaultProps = {
        min: 5000,
        max: 86399000,
    };
    return DurationInput;
}(React.Component));
export default DurationInput;
//# sourceMappingURL=index.js.map